import { TMessage } from "../i18n/tt";

export enum ValidationError {
  BlankName = "BlankName",
  InvalidEmail = "InvalidEmail",
  InvalidPostalCode = "InvalidPostalCode",
  inconsistentShareholderData = "inconsistentShareholderData",
  unsupportedTransactionType = "unsupportedTransactionType",
  shareholdersMissing = "shareholdersMissing",
  powerOfAttorneyReceiverEmailAddressMissing = "powerOfAttorneyReceiverEmailAddressMissing",
  noRolesForCompany = "noRolesForCompany",
  nominalValueMissing = "nominalValueMissing",
  missingName = "missingName",
  missingFirstName = "missingFirstName",
  missingLastName = "missingLastName",
  missingEmail = "missingEmail",
  invalidEmail = "invalidEmail",
  missingPhoneNumber = "missingPhoneNumber",
  invalidPhoneCountryCode = "invalidPhoneCountryCode",
  invalidPhoneNumber = "invalidPhoneNumber",
  documentAlreadySigned = "documentAlreadySigned",
  missingCompanyroleId = "missingCompanyroleId",
  missingSocialSecurityNumber = "missingSocialSecurityNumber",
  invalidSocialSecurityNumber = "invalidSocialSecurityNumber",
  nonUniqueSocialSecurityNumber = "nonUniqueSocialSecurityNumber",
  invalidCountryCode = "invalidCountryCode",
  missingOrganisationNumber = "missingOrganisationNumber",
  invalidOrganisationNumber = "invalidOrganisationNumber",
  tooShortPassword = "tooShortPassword",
  passwordShouldContainUppercaseLetters = "passwordShouldContainUppercaseLetters",
  passwordShouldContainLowercaseLetters = "passwordShouldContainLowercaseLetters",
  passwordShouldContainNumbers = "passwordShouldContainNumbers",
  oldPasswordIncorrect = "oldPasswordIncorrect",
  createPassword_invalidRef = "createPassword_invalidRef",
  createPassword_missingUsername = "createPassword_missingUsername",
  createPassword_missingPassword = "createPassword_missingPassword",
  multipleTransactions = "multipleTransactions",
  noTransactions = "noTransactions",
  invalidNorwegianCompanyNumberLength = "invalidNorwegianCompanyNumberLength",
  invalidNorwegianCompanyNumberOnlyNumeric = "invalidNorwegianCompanyNumberOnlyNumeric",
  blankCompanyNumber = "blankCompanyNumber",
  missingSubscription = "missingSubscription",
  illegalPaymentMethod = "illegalPaymentMethod",
  invalidLockupEndDateDate = "invalidLockupEndDateDate",
  invalidLoanAmount = "invalidLoanAmount",
  illegalSplitRatio = "illegalSplitRatio",
  invalidSubscriptionForm = "invalidSubscriptionForm",
  missingCompanyRoles = "missingCompanyRoles",
}

export const validationErrorMessage: Record<ValidationError, TMessage> = {
  [ValidationError.BlankName]: { key: "BlankName" },
  [ValidationError.InvalidEmail]: { key: "InvalidEmail" },
  [ValidationError.InvalidPostalCode]: { key: "InvalidPostalCode" },
  [ValidationError.inconsistentShareholderData]: { key: "general-error" },
  [ValidationError.unsupportedTransactionType]: { key: "error.unsupportedTransactionType" },
  [ValidationError.shareholdersMissing]: { key: "general-error" },
  [ValidationError.powerOfAttorneyReceiverEmailAddressMissing]: { key: "error.missingEmail" },
  [ValidationError.noRolesForCompany]: { key: "general-error" },
  [ValidationError.nominalValueMissing]: { key: "shareholders.error.nominalValueMissing" },
  [ValidationError.missingName]: { key: "error.missingName" },
  [ValidationError.missingFirstName]: { key: "error.missingFirstName" },
  [ValidationError.missingLastName]: { key: "error.missingLastName" },
  [ValidationError.missingEmail]: { key: "messaging.missingEmail" },
  [ValidationError.invalidEmail]: { key: "InvalidEmail" },
  [ValidationError.missingPhoneNumber]: { key: "error.missingPhoneNumber" },
  [ValidationError.invalidPhoneCountryCode]: { key: "invalidPhoneNumber" },
  [ValidationError.invalidPhoneNumber]: { key: "invalidPhoneNumber" },
  [ValidationError.documentAlreadySigned]: { key: "signing.fetchedError" },
  [ValidationError.missingCompanyroleId]: { key: "general-validation-error" },
  [ValidationError.missingSocialSecurityNumber]: { key: "missingSocialSecurityNumber" },
  [ValidationError.invalidSocialSecurityNumber]: { key: "invalidSocialSecurityNumber" },
  [ValidationError.nonUniqueSocialSecurityNumber]: { key: "nonUniqueSocialSecurityNumber" },
  [ValidationError.invalidCountryCode]: { key: "error.invalidCountryCode" },
  [ValidationError.missingOrganisationNumber]: { key: "error.missingOrganisationNumber" },
  [ValidationError.invalidOrganisationNumber]: { key: "error.invalidOrganisationNumber" },
  [ValidationError.tooShortPassword]: { key: "user-settings.weak-password" },
  [ValidationError.passwordShouldContainUppercaseLetters]: { key: "user-settings.weak-password" },
  [ValidationError.passwordShouldContainLowercaseLetters]: { key: "user-settings.weak-password" },
  [ValidationError.passwordShouldContainNumbers]: { key: "user-settings.weak-password" },
  [ValidationError.oldPasswordIncorrect]: { key: "user-settings.old-password-incorrect" },
  [ValidationError.createPassword_invalidRef]: { key: "general-error" },
  [ValidationError.createPassword_missingUsername]: { key: "general-validation-error" },
  [ValidationError.createPassword_missingPassword]: { key: "general-validation-error" },
  [ValidationError.multipleTransactions]: { key: "error.multipleTransactions" },
  [ValidationError.noTransactions]: { key: "error.noTransactions" },
  [ValidationError.invalidNorwegianCompanyNumberLength]: {
    key: "invalidNorwegianCompanyNumberLength",
  },
  [ValidationError.invalidNorwegianCompanyNumberOnlyNumeric]: {
    key: "invalidNorwegianCompanyNumberOnlyNumeric",
  },
  [ValidationError.blankCompanyNumber]: { key: "error.missingOrganisationNumber" },
  [ValidationError.missingSubscription]: { key: "error.missingSubscription" },
  [ValidationError.illegalPaymentMethod]: { key: "general-error" },
  [ValidationError.invalidLockupEndDateDate]: { key: "error.invalidLockupEndDateDate" },
  [ValidationError.invalidLoanAmount]: { key: "error.invalidLoanAmount" },
  [ValidationError.illegalSplitRatio]: { key: "shareholders.error.illegalSplitRatio" },
  [ValidationError.invalidSubscriptionForm]: {
    key: "signing.subscription.form.error.invalidSubscriptionForm",
  },
  [ValidationError.missingCompanyRoles]: { key: "general-error" },
};
